import { bindActionCreators } from 'redux';
import { connect, confirmSessionStartPage, submitStudentAccessCode, set, getExistingQuiz, getQuizById, getQuizSessionById, featureOn } from '@instructure/quiz-core';
import { STUDENT_ACCESS_CODE_STATUS, STUDENT_ACCESS_CODE_VALUE, SESSION_LOCK_VALIDITY } from '@instructure/quiz-common';
import { Show as ShowPresenter } from './presenter';
export function mapStateToProps(state, _ref) {
  var quizId = _ref.quizId,
    quizSessionId = _ref.quizSessionId;
  var quizSession = quizSessionId ? getQuizSessionById(state, quizSessionId) : null;
  var quiz = getQuizById(state, quizSession ? quizSession.quiz : quizId);
  var allowBacktracking = quiz.allowBacktracking;
  var isOneAtATime = quiz.isOneQuestionAtATime();
  var shouldShowLinkButton = !quiz.requireStudentAccessCode;

  // We don't always get a quizSession for the Show page, sometimes it's just a quiz
  if (quizSession) {
    if (!quizSession.pending()) {
      allowBacktracking = quizSession.allowBacktracking;
      isOneAtATime = quizSession.isOneQuestionAtATime();
    }
    shouldShowLinkButton = shouldShowLinkButton || quizSession.submitted() || quizSession.acceptedStudentAccessCode;
  }
  return {
    allowBacktracking: allowBacktracking,
    isOneAtATime: isOneAtATime,
    shouldShowLinkButton: shouldShowLinkButton,
    shouldShowBeginButton: shouldShowLinkButton && quiz.quizEntriesCount > 0,
    quiz: quiz,
    quizSession: quizSession,
    accessCode: state.getIn(['ui', STUDENT_ACCESS_CODE_VALUE], ''),
    accessCodeStatus: state.getIn(['ui', STUDENT_ACCESS_CODE_STATUS]),
    isValidSessionLock: state.getIn(['ui', SESSION_LOCK_VALIDITY], true),
    shouldShowMultipleSessionsWarning: featureOn('detect_multiple_sessions') && quiz.detectMultipleSessions,
    shouldStoreSessionLock: featureOn('detect_multiple_sessions')
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmSessionStartPage: bindActionCreators(confirmSessionStartPage, dispatch),
    submitStudentAccessCode: bindActionCreators(submitStudentAccessCode, dispatch),
    getExistingQuiz: bindActionCreators(getExistingQuiz, dispatch),
    updateAccessCodeUi: function updateAccessCodeUi(code) {
      return dispatch(set(STUDENT_ACCESS_CODE_VALUE, code));
    },
    clearAccessCodeStatus: function clearAccessCodeStatus() {
      return dispatch(set(STUDENT_ACCESS_CODE_STATUS, void 0));
    },
    updateSessionLockValidity: function updateSessionLockValidity(isValid) {
      return dispatch(set(SESSION_LOCK_VALIDITY, isValid));
    }
  };
};
export var Show = connect(mapStateToProps, mapDispatchToProps)(ShowPresenter);
export default Show;